module.exports = __webpack_public_path__ + "img/psArena.cf2d22ea.jpeg";